var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 384,
    viewBox: "0 0 320 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0C21.5 0 0 21.5 0 48V336C0 362.5 21.5 384 48 384H80C106.5 384 128 362.5 128 336V48C128 21.5 106.5 0 80 0H48ZM240 0C213.5 0 192 21.5 192 48V336C192 362.5 213.5 384 240 384H272C298.5 384 320 362.5 320 336V48C320 21.5 298.5 0 272 0H240Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.6a62321128ab42cba17fe7694eb306d6.svg";
export { ForwardRef as ReactComponent };